import { ForwardedRef, forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react"
import Overlay from "./Overlay"
import Transition, { ITransition } from "../Transition/Transition"
import GUI from "../GUI"
import { IBackdrop, TBackdropProps } from "./Backdrop"

export type TFullscreenBackdropProps = TBackdropProps & {
    isTop:boolean
}

export default forwardRef( (props:TFullscreenBackdropProps, ref?:ForwardedRef<IBackdrop>) => {
    const [show,setShow] = useState<boolean>(true)
    const {overlayProps} = props
    const refSelf = useRef<ITransition|null>(null)

    const onDown = (e:PointerEvent) => {
        e.stopPropagation()
        if (!props.active || !refSelf.current) return false

        // find overlay within self
        const overlay = refSelf.current.target?.querySelector(".overlay")
        if (!overlay) return false

        // if within overlay, dont' close
        const element = document.elementFromPoint(e.clientX, e.clientY)
        if (overlay.contains(element)) return true

        // check if it can close
        if (overlayProps.modal || (overlayProps.canDismiss && !overlayProps.canDismiss(e))) return true
        else props.onDismiss(props.overlayId)
        return true
    }
    useImperativeHandle(ref, () => ({onDown}), [])
    const capture = () => {
        const scrollY = window.scrollY
        document.body.style.position = "fixed"
        document.body.style.top = `-${scrollY}px`
        document.body.style.width = "100%";
    }
    const release = () => {
        document.body.style.position = ""
        document.body.style.top = ""
        document.body.style.width = ""
        window.scrollTo(0, scrollY)
    }

    // backdrop is gone
    const onDestroy = () => props.onDismissed(props.overlayId)
    
    // overlay is dimissed
    const onDismissed = () => setShow(false)

    useEffect(() => {
        props.index==0 && capture()
        return () => { props.index==0 && release() }
    }, [])

    // const {className:backdropClassName, onMouseDown, onTouchStart, ...backdropProps} = props.backdropProps
    const content = show ? <Overlay {...overlayProps} open={props.active} afterLeaving={onDismissed}/> : null
    const className = GUI.joinClass("backdrop", props.isTop ? "" : "light", props.overlayProps.backdropClass)
    const id = props.id ? {id:props.id} : {}
    return <Transition overlay-id={props.overlayId} className={className} afterLeaving={onDestroy} transition="fade" {...id} ref={refSelf}>{content}</Transition>
})
